import { type FC, type ReactNode } from "react";
import { useToken, useUser } from "@packsize/authentication";
import { usePendo } from "@packsize/application-monitoring";

import { environment } from "@/environment";
import { useTenantStatus } from "@/hooks/use-tenant-status";

interface PendoProps {
	readonly children: ReactNode;
}

const Pendo: FC<PendoProps> = ({ children }) => {
	const { decodedToken } = useToken();
	const { currentUser } = useUser();
	const tenantStatus = useTenantStatus();

	usePendo(environment, decodedToken, currentUser, tenantStatus);

	return children;
};

export default Pendo;
